<template>
  <div class="p-14 flex flex-col items-center justify-center">
    <VerifyPhoneIcon v-if="forPhone" class="mb-8" />
    <VerifyEmailIcon v-if="forEmail" class="mb-8" />

    <p class="text-body-5 font-medium text-default-1 mb-3">Attention!</p>
    <p class="text-body-6 text-default-1 text-center mb-6">
      Changing this {{ contact }}, you will change your login for Connect Plus+
    </p>

    <div class="flex flex-row">
      <CoreButton buttonType="primary" label="Ok" size="default" @click="emit('acceptTerms', {type: type, accepted: true})" class="mr-2" />
      <CoreButton buttonType="secondary" label="Cancel" size="default" @click="emit('close')" />
    </div>
  </div>
</template>
<script setup>
import CoreButton from '@/components/core/Button.vue';
import VerifyPhoneIcon from '@/components/icons/phone/Verify.vue';
import VerifyEmailIcon from '@/components/icons/email/Verify.vue';
import {computed} from "vue";

const props = defineProps({
    type: {
        type: String,
        required: true,
    },
    contact: {
        type: String,
        required: true,
    },
});

const emit = defineEmits(['acceptTerms', 'close']);

const forEmail = computed(() => props.type === 'email');
const forPhone = computed(() => props.type === 'phone');

</script>
